export default __webpack_public_path__ + "static/media/icon-sad-face-full.d10d92f5.svg";